import React from 'react';
import { Input, Button, Select, Textarea, Table } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { connect } from 'react-redux';
import { ReportService } from 'services';
import { 
	FacebookSquareIcon,
	InstagramSquareIcon,
	WhatsappSquareIcon,
	ApiSquareIcon,
	TiktokSquareIcon
} from 'assets/icons';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		header: [
			'Producto',
			'Cantidad',
			'Precio',
			'Total'
		],
		item: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ReportService.admin.sales.view({
			sale_id: this.props.item?.id
		});
		this.setState({
			item: res.sale
		});
	}

	getIcon = (item: any) => {
		if (item?.facebook_id) {
			return FacebookSquareIcon;
		}
		else if (item?.phone) {
			return WhatsappSquareIcon;
		}
		else if (item?.instagram_id) {
			return InstagramSquareIcon;
		}
		else if (item?.tiktok_id) {
			return TiktokSquareIcon;
		}
		else {
			return ApiSquareIcon;
		}
	}
	
	render() {
		const item: any = this.state.item;

		return (
			<div id="modal-view-sale">
				<div className="row">
					{
						this.props.user?.level_id != Constants.LEVELS.CLIENT && (
							<div className="col-md-4">
								<p className="bold">Usuario:</p>
								<p className="value">{ item?.user != null ? (item?.user?.name + ' ' + item?.user?.lastname) : '-' }</p>
							</div>
						)
					}
					<div className="col-md-4">
						<p className="bold">Cliente:</p>
						<p className="value">{ item?.name || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Teléfono:</p>
						<p className="value">{ item?.phone || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Documento de Identidad:</p>
						<p className="value">{ item?.document || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Método de Pago:</p>
						<p className="value">{ item?.payment_method || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Método de Envío:</p>
						<p className="value">{ item?.shipping?.name || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Nº de Referencia:</p>
						<p className="value">{ item?.reference || '-' }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Vía:</p>
						<p className="value">
							<img src={ this.getIcon(item?.session) } className="session-icon" />
						</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Conexión:</p>
						<p className="value">{ item?.session?.name || item?.session?.phone || item?.session?.value }</p>
					</div>
					<div className="col-md-4">
						<p className="bold">Total:</p>
						<p className="value">{ Globals.formatMiles(item?.total,true,item?.currency) }</p>
					</div>
				</div>
				<Table data={ item?.details } header={ this.state.header }>
					{
						item?.details?.map((product: any) => {
							return (
								<tr>
									<td>{ product?.product?.name }</td>
									<td>{ product?.quantity }</td>
									<td>{ Globals.formatMiles(product?.price) }</td>
									<td>{ Globals.formatMiles(product?.total) }</td>
								</tr>
							)
						})
					}
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalView);